// Re-export LanguageSelector provided by the library
import { LanguageSelector } from '@edusense/i18n';
export { LanguageSelector };
export default LanguageSelector;